import { render, staticRenderFns } from "./rightPanel.vue?vue&type=template&id=6b5fccfa&scoped=true"
import script from "./rightPanel.vue?vue&type=script&lang=js"
export * from "./rightPanel.vue?vue&type=script&lang=js"
import style0 from "./rightPanel.vue?vue&type=style&index=0&id=6b5fccfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fccfa",
  null
  
)

export default component.exports